import React, { useContext } from 'react';
import LineItem from '../models/LineItem'
import LineItemRecur from '../models/LineItemRecur'
import {RecursContext} from './Recurs'

const LineItemsContext = React.createContext();

const LineItemsProvider = (props) => {

  const [recurs] = useContext(RecursContext)

  let lineItemsCountRecurring = 0
  const lineItemProps = (props && props.value || []).sort((a, b) => {
    return new Date(b.processed_at) - new Date(a.processed_at)
  })

  // shopper#406 : group recurring line items
  const lineItemsByPlanId = lineItemProps.reduce((lineItemsByPlanId, lineItemProps) => {
    const planId = lineItemProps.subscription_plan_id
    if (planId) {
      lineItemsByPlanId[planId] ||= []
      lineItemsByPlanId[planId].push(lineItemProps)
    }
    return lineItemsByPlanId
  }, {})

  const lineItems = lineItemProps.reduce((lineItemsArr, lineItemProps) => {
    const planId = lineItemProps.subscription_plan_id
    const order_id = lineItemProps.order_id
    const lineItemRecur = !props.noGroupRecurring && planId && lineItemsArr.find((lineItem) => lineItem.subscription_plan_id == planId && lineItem.order_id != order_id)
    if (!lineItemRecur) {
      let lineItem;
      if (planId) {
        const recur = recurs.find((recur) => recur.matches(order_id))
        lineItem = LineItemRecur(lineItemProps, recur)
      } else {
        lineItem = LineItem(lineItemProps)
      }
      lineItemsArr.push(lineItem)
    } else {
      // shopper#646 : add payments from other recurring line items (Restart Subscription)
      const recur = recurs.find((recur) => recur.matches(order_id))
      if (lineItemRecur.recur && lineItemRecur.recur.id !== recur.id) {
        lineItemRecur.addPayments(recur.payments)
      }
      lineItemsCountRecurring++
    }

    return lineItemsArr
  }, [])

  if (lineItemsCountRecurring) {
    console.log(`${lineItemsCountRecurring} recurring lineItems removed`)
  }

  props.onLineItems && props.onLineItems(lineItems)

  return (
    <LineItemsContext.Provider value={lineItems}>
      {props.children}
    </LineItemsContext.Provider>
  );
};

export { LineItemsContext, LineItemsProvider}
